import { createContext, useContext } from "react";
import type { RouteObject } from "react-router";

const RouteConfigContext = createContext<RouteObject[]>([]);

export const RouteProvider = ({
  children,
  routes,
}: { children: React.ReactNode; routes: RouteObject[] }) => {
  return (
    <RouteConfigContext.Provider value={routes}>
      {children}
    </RouteConfigContext.Provider>
  );
};

export const useRouteConfig = () => useContext(RouteConfigContext);
